import { useMemo } from 'react'
import { Button } from '@/components/ui/button'
import { TriangleRightIcon, TriangleDownIcon } from '@radix-ui/react-icons'
import { ASMTreeNode } from '@/state'
import { useCADPageStore } from '@/state'
import { useShallow } from 'zustand/react/shallow'

export const CollapsibleTreeNodeButton = ({
  node,
  enabled,
}: {
  node: ASMTreeNode
  enabled?: boolean
}) => {
  const toggleAssemblyTreeNode = useCADPageStore(
    useShallow((state) => state.toggleAssemblyTreeNode),
  )

  const expandedAssemblyTreeNodes = useCADPageStore(
    (state) => state.expandedAssemblyTreeNodes,
  )

  const TriangleIcon = useMemo(() => {
    const isOpen = expandedAssemblyTreeNodes.includes(node.uuid)
    return isOpen ? TriangleDownIcon : TriangleRightIcon
  }, [expandedAssemblyTreeNodes, node.uuid])

  return enabled ? (
    <Button
      variant="ghost"
      className="px-1 py-0 h-6"
      onMouseDown={(e) => {
        e.preventDefault()
        e.stopPropagation()
        toggleAssemblyTreeNode(node.uuid)
      }}
    >
      <TriangleIcon className="w-5 h-5 text-gray-600 w-5 h-5" />
    </Button>
  ) : (
    <CollapsibleTriggerPlaceHolder />
  )
}

const CollapsibleTriggerPlaceHolder = () => {
  return (
    <div
      style={{
        minWidth: 24,
        width: 24,
        height: 24,
        marginRight: 6,
      }}
    ></div>
  )
}
